var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-dusk":"global-automation-configuration-badge"}},[_vm._v("\n  "+_vm._s(_vm.globalAutomationConfigurationName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }